import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface NoImagesPlaceholderProps {
  onAddClick: () => void;
}

const NoImagesPlaceholder = ({ onAddClick }: NoImagesPlaceholderProps) => {
  return (
    <div className="text-center p-8 border border-dashed rounded-md">
      <p className="text-muted-foreground mb-4">No images added yet</p>
    </div>
  );
};

export default NoImagesPlaceholder;
